import React, { FC } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import Dialog from '../common/Dialog';
import { USE_DRM } from '../../utils/types';

export const PEACOCK_DRM_PROVIDER = 'Arcus';
export const PLAY_FACTORY_DRM_PROVIDER = 'PlayFactory';

export const DRM_PROVIDERS = [PEACOCK_DRM_PROVIDER, PLAY_FACTORY_DRM_PROVIDER];

type DrmProviderDialogProps = {
	open: boolean;
	mode: USE_DRM.YES | USE_DRM.BOTH;
	mAltId: string;
	drmProvider: string;
	onMaltIdChange: (value: string) => void;
	onDrmProviderChange: (value: string) => void;
	onOK: () => void;
	onCancel: () => void;
};

const DrmProviderDialog: FC<DrmProviderDialogProps> = ({
	open,
	mode,
	mAltId,
	drmProvider,
	onMaltIdChange,
	onDrmProviderChange,
	onOK,
	onCancel
}) => {
	const isRequired = mode === USE_DRM.YES;
	const resolvedProvider = DRM_PROVIDERS.includes(drmProvider) ? drmProvider : PEACOCK_DRM_PROVIDER;

	return (
		<Dialog open={open} onOK={onOK} onCancel={onCancel} title='DRM Configuration' maxWidth='sm'>
			<Typography variant='body2' gutterBottom>
				{isRequired
					? 'DRM functionality is enabled - please enter a valid Merlin Alternate Id for this Airing.'
					: 'Optionally, provide a valid Merlin Alternate Id to activate DRM functionality on this Airing. Leave empty to exclude DRM.'}
			</Typography>

			<TextField
				label='Merlin Alternate Id'
				value={mAltId}
				onChange={(e): void => onMaltIdChange(e.target.value)}
				fullWidth
				margin='normal'
				required={isRequired}
			/>

			<FormControl fullWidth margin='normal'>
				<InputLabel>DRM Provider</InputLabel>
				<Select value={resolvedProvider} onChange={(e): void => onDrmProviderChange(e.target.value as string)}>
					{DRM_PROVIDERS.map((provider) => (
						<MenuItem key={provider} value={provider}>{provider}</MenuItem>
					))}
				</Select>
			</FormControl>
		</Dialog>
	);
};

export default DrmProviderDialog;
